import { Skeleton } from "@/components/ui/skeleton";

export function JobListSkeleton() {
  return (
    <div className="space-y-4">
      <Skeleton className="h-12 w-64 mb-8" />
      <Skeleton className="h-10 w-full max-w-md mb-8" />
      
      {/* Highlighted Categories Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="border rounded-lg p-4">
            <Skeleton className="h-8 w-3/4 mb-4" />
            <Skeleton className="h-20 w-full mb-4" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-1/2" />
              <Skeleton className="h-4 w-1/3" />
            </div>
          </div>
        ))}
      </div>

      {/* Job Categories Skeleton */}
      {[1, 2, 3].map((i) => (
        <div key={i} className="border rounded-lg">
          <div className="flex">
            <Skeleton className="h-16 w-1/4" />
            <Skeleton className="h-16 flex-1 ml-1" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function CareerPageSkeleton() {
  return (
    <>
      <section className="relative w-full min-h-screen overflow-hidden p-4 sm:p-8 pt-20 flex items-center bg-[#f7f9fc]">
        {/* Background banner skeleton */}
        <div className="absolute right-0 top-0 h-screen w-full lg:w-4/5 overflow-hidden">
          <div className="h-full w-full lg:rounded-l-[48px] overflow-hidden">
            <Skeleton className="w-full h-full lg:rounded-l-[48px]" />
          </div>
        </div>

        {/* Content Card skeleton */}
        <div className="relative container mx-auto">
          <div className="relative z-10 w-full">
            <div className="w-full max-w-[600px] bg-white/95 lg:bg-white rounded-3xl p-4 sm:p-6 md:p-8 lg:p-12 shadow-xl">
              <div className="space-y-4 sm:space-y-5 md:space-y-6">
                <Skeleton className="h-8 sm:h-9 w-3/4" />
                <Skeleton className="h-4 sm:h-5 w-full" />
                <Skeleton className="h-4 sm:h-5 w-5/6" />
                <div className="pt-2 sm:pt-4 flex flex-wrap gap-3 sm:gap-4">
                  <Skeleton className="h-10 sm:h-11 w-40 sm:w-48 rounded-full" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Skeleton for other sections */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4 space-y-10">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-64 w-full rounded-2xl" />
        </div>
      </section>
    </>
  );
}

export function LifeAtDanaSkeleton() {
  return (
    <div className="grid lg:grid-cols-2 gap-12">
      {/* Left Column */}
      <div className="space-y-8">
        <Skeleton className="aspect-video w-full rounded-lg" />
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-[400px] w-[600px] rounded-lg" />
      </div>

      {/* Right Column */}
      <div>
        <Skeleton className="h-10 w-48 mb-4" />
        <Skeleton className="h-6 w-64 mb-8" />
        
        <div className="grid gap-6">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="border rounded-lg p-6">
              <div className="flex">
                <Skeleton className="h-8 w-8 mr-4" />
                <div className="flex-1">
                  <Skeleton className="h-6 w-3/4 mb-2" />
                  <Skeleton className="h-4 w-full" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 